import axios from "axios"
import React, { Component } from "react"
import { Button, Modal, Spinner } from "react-bootstrap"
import AxiosConfig from "../../../../utilities/AxiosConfig"
//@ts-ignore
import FileViewer from "react-file-viewer"
import snackBar from "../../../../utilities/snackBar/SnackBar"
import IconBuilder from "../../../../utilities/iconBuilder/IconBuilder"
import DocDownloader from "../DocDownloader/DocDownloader"
import "./DocViewer.css"

interface Props {
    fileName: string | null
    extension: string | null
    toggleDocViewer: Function
    getFileTitle: Function
    displayName: string
    containerName: string
    storageLocation: string
}

interface State {
    file: any | null
    b64: string | null
    path: string | null
    extension: string | null
    name: string | null
    loadingFile: boolean
    download: boolean
}

class DocViewer extends Component<Props, State> {

    state = {
        file: null,
        b64: null,
        path: "",
        extension: null,
        name: null,
        loadingFile: false,
        download: false
    }

    componentDidMount() {
        this.getDocument()
    }

    componentWillUnmount() {
        this.setState({
            file: null,
            path: "",
            extension: null,
            name: null,
            loadingFile: false,
        })
    }

    base64ToFile = (base64String: any) => {
        let str = atob(base64String)
        let i = str.length
        let u8arr = new Uint8Array(i)
        while (i--) {
            u8arr[i] = str.charCodeAt(i)
        }
        return new File([u8arr], "file-preview")
    }


    getDocument = () => {
        this.setState({ loadingFile: true })
        axios.get(process.env.REACT_APP_IMG_API_URL + `/api/file/secureGet/${this.props.containerName}/${this.props.storageLocation}/${this.props.fileName}/`, AxiosConfig.configValue("min"))
            .then(res => {
                const file = this.base64ToFile(res.data);
                this.setState({ file: URL.createObjectURL(file), b64: res.data, loadingFile: false })
            }).catch(() => {
                this.setState({ loadingFile: false })
                snackBar({ type: "error", text: "Failed to fetch file", timeout: 3000 })
                this.props.toggleDocViewer()
            })
    }

    toggleDownload = () => {
        this.setState({ download: !this.state.download })
    }

    render() {

        const state = this.state
        const props = this.props
        const file = state.file
        const extension = props.extension?.toLowerCase() || ""

        // console.log("state:", state)
        // console.log("props:", props)

        return (
            <div className="DocViewer">
                <Modal
                    id="doc-viewer-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                    size="xl"
                >
                    <Modal.Header>
                        <div className="DocViewerModalHeader">
                            <IconBuilder
                                extension={extension}
                                size={64}
                            />
                            <p>{this.props.displayName}</p>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="DocViewerModalBody">
                            {file && extension !== "pdf" &&
                                <FileViewer
                                    fileType={extension}
                                    filePath={file}
                                    errorComponent={<div></div>}
                                    onError={() => snackBar({ type: "error", text: "Failed to load file", timeout: 3000 })}
                                />}
                            {this.state.b64 && extension === "pdf" &&
                                <div className="DocViewerModalBodyPDFViewer">
                                    <iframe
                                        //@ts-ignore
                                        src={`data:application/pdf;base64, ${encodeURI(this.state.b64)}`}
                                        style={{ width: "100%", height: "100%" }}
                                    >
                                    </iframe>
                                </div>}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="DocViewerModalFooter">
                            {state.loadingFile && <Spinner id="doc-viewer-modal-spinner" animation="border" />}
                            {file && <DocDownloader
                                file={file}
                                extension={extension}
                                fileName={props.fileName}
                                toggleDownload={this.toggleDownload}
                                displayName={props.displayName}
                            />}
                            <Button id="doc-viewer-modal-footer-back-btn" variant="secondary" onClick={() => props.toggleDocViewer()}>Back</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default DocViewer